import {Divider, List, Modal} from "semantic-ui-react";
import {interpolateString} from "../utils/localization";
import React from "react"
import {connect} from "react-redux";
import {getArrayByLanguage, isAIG, isNationwide} from "../utils/common";
import {CustomModalHeader} from "./custom-common";
import {BenefitLimitsRequest} from "../services/types";
import {benefitLimitsService} from "../services/services";


const mapStateToProps = ({user, initialData}, ownProps) => {
    const {policy, ratedClass, limitations, contractInfo} = initialData;

    return {
        ...ownProps,
        ageReduction: policy.ageReduction,
        ageReductionAge: policy.ageReductionAge,
        ageReductionPercentage: policy.ageReductionPercentage,
        benefitWaitingPeriod: policy.benefitWaitingPeriod,
        maxEligibilityAge: policy.maxEligibilityAge,
        severeSeparationPeriod: policy.severeSeparationPeriod,
        moderateSeparationPeriod: policy.moderateSeparationPeriod,
        catastrophicSeparationPeriod: policy.catastrophicSeparationPeriod,
        catastrophicMaximumOccurrences: policy.catastrophicRecurrencyLimit,
        lang: user.lang,
        limitations,
        contractTerms: ratedClass.contractTerms,
        portability: ratedClass.contractTerms.portability,
        statePostalCode: contractInfo.issueState,
    }
};


const LimitationsExclusionsModal = (props) => {
    const { limitations, strings, renderModal, closeModal, ageReduction, ageReductionAge, ageReductionPercentage,
        benefitWaitingPeriod, maxEligibilityAge, contractTerms, lang, portability, statePostalCode} = props;
    const filteredExclusions = getArrayByLanguage(limitations, lang);
    const portabilityConditionalText = portability === "Included" ? [strings.portabilityConditionalText] : [''];

    const [benefitLimits, setBenefitLimits] = React.useState(null);

    React.useEffect(() => {
        if (!benefitLimits) {
            async function getBenefitLimits() {
                const payload = new BenefitLimitsRequest({
                    contractTerms,
                    languageCode: lang,
                    statePostalCode
                })
                const data = await benefitLimitsService(payload);
                return data;
            }

            getBenefitLimits().then(benefitLimitsData => setBenefitLimits(benefitLimitsData));
        }
    }, [lang, statePostalCode, contractTerms, benefitLimits]);

    return <Modal onClose={closeModal} open={renderModal}>
        <CustomModalHeader title={strings.title} onClose={closeModal}/>
        <Modal.Content style={{maxHeight: '513px', overflowY: 'auto'}} className={"small"}>
            <p>{strings.aCompleteDescr}</p>
            <p style={{fontSize: '16px'}}><b>{strings.limitations}</b></p>
            <p>{strings.brellaWillPay}{benefitLimits?.subjectToText}. {benefitLimits?.adminChangeText}</p>
            <div style={{marginLeft: '1.5em'}}>
                {benefitLimits?.explanations?.map(({title, description}) =>
                    <p key={title}><b>{title}:</b><br/>{description}</p>
                )}
            </div>

            <Divider hidden/>
            <p style={{fontSize: '16px'}}><b>{strings.exclusions}</b></p>
            {filteredExclusions.map((item, i) => (
                <React.Fragment key={i}>
                    <p>{item.title}</p>
                    <div style={{marginLeft: '1.5em'}}>
                        <List className={'limitationsAndExclusionsList'}>
                            {item.items.map((it) => <List.Item key={it.bullet}>{it.bullet}) {it.title}</List.Item>)}
                        </List>
                    </div>
                    {i !== filteredExclusions.length - 1 && <Divider hidden/>}
                </React.Fragment>
            ))}
            {!!ageReduction &&
                <React.Fragment>
                    <Divider hidden/>
                    <p style={{fontSize: '16px'}}><b>{strings.reductionsOfCoverage}</b></p>
                    <p>{interpolateString(strings.benefitsMayBeReduced, [ageReductionAge, ageReductionPercentage, maxEligibilityAge])}</p>
                </React.Fragment>
            }

            {!!benefitWaitingPeriod &&
                <>
                    <Divider hidden/>
                    <p style={{fontSize: '16px'}}><b>{strings.waitingPeriods}</b></p>
                    <p>{interpolateString(strings.ifYouEnroll, [benefitWaitingPeriod])} {benefitLimits?.coveredDuringBenefitWaitingPeriodText} {!isNationwide() && benefitLimits?.waitingPeriodsAdditionalText}</p>
                </>
            }
            { !isAIG() &&
                <>
                    <Divider hidden/>
                    <p style={{fontSize: '16px'}}><b>{strings.renew}</b></p>
                    <p>{interpolateString(strings.ourPlansAre, portabilityConditionalText)}</p>
                    <br/>
                </>
            }
        </Modal.Content>
    </Modal>
}

export default connect(mapStateToProps)(LimitationsExclusionsModal);
